import { createComponent } from '../lib';
import { VmAudio, VmFile } from '@vime/core';
import { define } from '../lib';
define('vm-audio', VmAudio);
define('vm-file', VmFile);
;
export default createComponent('vm-audio', new Set(['willAttach', 'crossOrigin', 'preload', 'disableRemotePlayback', 'mediaTitle']));
